"use client";

import AppError from "@/app/(app)/error";
import { JsonTranslationsProvider } from "@/contexts/JsonTranslationsContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import "./globals.css";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en" suppressHydrationWarning>
      <body>
        <JsonTranslationsProvider value={{}}>
          <LanguageProvider initialLanguage="en">
            <AppError error={error} reset={reset} />
          </LanguageProvider>
        </JsonTranslationsProvider>
      </body>
    </html>
  );
}
